import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIHelpIcon from 'UIComponents/icon/UIHelpIcon';
import UIFlex from 'UIComponents/layout/UIFlex';
import UILink from 'UIComponents/link/UILink';
import { getPaidUserSettingsUrl } from '../../urls/getPaidUserSettingsUrl';
import AssigneeOptionContainer from './AssigneeOptionContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AssignToTeamHeaderHD = ({
  canRouteToAvailable,
  isUngatedForHelpDeskRoutingScopeFiltering
}) => /*#__PURE__*/_jsx(AssigneeOptionContainer, {
  children: /*#__PURE__*/_jsxs(UIFlex, {
    className: "p-left-1 p-right-2",
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      className: "m-right-1",
      message: "routing-ui.reassignment.assignToTeam"
    }), !isUngatedForHelpDeskRoutingScopeFiltering && /*#__PURE__*/_jsx(UIHelpIcon, {
      title: /*#__PURE__*/_jsxs(_Fragment, {
        children: [canRouteToAvailable && /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "routing-ui.reassignment.teamSectionHelp.paragraph"
          })
        }), /*#__PURE__*/_jsx("p", {
          className: "m-y-0",
          children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
            message: "routing-ui.reassignment.teamSectionHelp.link_jsx",
            elements: {
              UILink
            },
            options: {
              external: true,
              href: getPaidUserSettingsUrl()
            }
          })
        })]
      })
    })]
  })
});
AssignToTeamHeaderHD.displayName = 'AssignToTeamHeaderHD';
export default AssignToTeamHeaderHD;